import { arrayOf, bool, number, object, oneOfType, string } from 'prop-types'
import { Card } from '@winnin/winnin_ui.components.card'
import { Icon } from '@winnin/winnin_ui.components.icon'
import { Loading } from '@winnin/winnin_ui.components.loading'
import { Title } from '@winnin/winnin_ui.components.title'
import { TooltipWrapper } from '@winnin/winnin_ui.components.tooltip-wrapper'

import CountryGraphPaginated from 'components/CountryGraphPaginated'
import NoDataAvailable from 'components/NoDataAvailable'
import WorldMap from 'components/WorldMap'
import { useTranslate } from 'lib/tolgee'
import TOLGEE_GLOBALS from 'utils/tolgeeGlobals'
import './index.scss'

const SIZE_MAP = {
  xlg: 'h1',
  lg: 'h2',
  md: 'h3',
  sm: 'h4',
  xs: 'h5',
  xxs: 'h6',
}

const MapAndCountriesCard = props => {
  const {
    countries,
    loading,
    title = '',
    header = '',
    hideWorldMap = false,
    width = 620,
    height = 360,
    size = 'md',
  } = props

  const t = useTranslate()
  const filtered = countries.filter(v => v.percent > 0.01)

  const hasCountries = countries && countries.length > 0

  return (
    <div className="title-content">
      {title && (
        <Title tag={SIZE_MAP[size]} className="title">
          {title || 'By Country'}
          <TooltipWrapper
            tooltipMessage={t(TOLGEE_GLOBALS.audienceReasoning)}
            isTooltipMultiline
            tooltipStyle="tooltippedE"
          >
            <Icon icon="questionMark" width={28} height={28} />
          </TooltipWrapper>
        </Title>
      )}
      {header && <>{header}</>}
      <Card className="by-country-card content">
        {!loading && hasCountries && (
          <div className="content">
            {!hideWorldMap ? <WorldMap data={filtered} /> : null}
            <CountryGraphPaginated count={5} countries={countries} paginated width={width} height={height} />
          </div>
        )}
        {loading && <Loading />}
        {!hasCountries && <NoDataAvailable />}
      </Card>
    </div>
  )
}

MapAndCountriesCard.propTypes = {
  countries: arrayOf(object),
  loading: bool,
  title: string,
  header: oneOfType([string, object]),
  hideWorldMap: bool,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  size: string,
}

export default MapAndCountriesCard
